<template>
  <div class="info-wrapper">
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">项目名称：</el-col>
      <el-col :span="14" class="info-txt">{{formData.projectName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">项目类型：</el-col>
      <el-col :span="14" class="info-txt">{{formData.proTypeName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">所在省市区：</el-col>
      <el-col :span="14" class="info-txt">{{formData.location|getCodeText}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">项目地址：</el-col>
      <el-col :span="14" class="info-txt">{{formData.projectAddr}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">协议(合同)编号：</el-col>
      <el-col :span="14" class="info-txt">{{formData.agreementNo}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">防雷类别：</el-col>
      <el-col :span="14" class="info-txt">{{formData.preTypeName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">检测类型：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkTypeName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">被检对象类型：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkObjTypeName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">被检对象名称：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkObjName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">检测单位证件号：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkObjNo}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">检测报告编号：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkReportNo}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">被检建筑物数量：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkBuildingNum}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">编制人员：</el-col>
      <el-col :span="14" class="info-txt">{{formData.operatorPersonName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">检测人员：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkPersonName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">复核人员：</el-col>
      <el-col :span="14" class="info-txt">{{formData.reviewPersonName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">检测日期：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkDate}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">批准人员：</el-col>
      <el-col :span="14" class="info-txt">{{formData.approvePersonName}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">创建日期：</el-col>
      <el-col :span="14" class="info-txt">{{formData.createTime}}</el-col>
    </el-row>
    <el-row :gutter="20" class="info-row">
      <el-col :span="10" class="info-label">检测结论：</el-col>
      <el-col :span="14" class="info-txt">{{formData.checkConclusion}}</el-col>
    </el-row>
  </div>
</template>
<script>
  import {getAction} from "../../service/http/api";
  export default {
    name: 'Info',
    data() {
      return {
        formData:{
          id:null,
          projectName:null,
          proTypeName:null,
          location:null,
          projectAddr:null,
          agreementNo:null,
          preTypeName:null,
          checkTypeName:null,
          checkObjTypeName:null,
          checkObjName:null,
          checkObjNo:null,
          checkReportNo:null,
          checkBuildingNum:null,
          operatorPersonName:null,
          checkPersonName:null,
          reviewPersonName:null,
          checkDate:null,
          approvePersonName:null,
          createTime:null,
          checkConclusion:null,
        }
      }
    },
    methods: {
      loadData(){
        var id = this.$route.params.id;
        getAction('/check/checkProject/queryById',{id}).then(res=>{
          if(res.code===200){
            this.formData = res.data;
          }
        })
      },
    },
    created() {
      this.loadData();
    }
  }
</script>

<style lang="scss" scoped>
  .info-wrapper{
    position: relative;
    padding: 30px 20px;
    font-size: 18px;
    &:before{
      position: absolute;
      display: block;
      content: '';
      right: 10%;
      top: 50px;
      width: 200px;
      height: 200px;
      background: url('../../assets/images/finish.png') 0/cover no-repeat;
    }
    .info-row{
      margin-bottom: 10px;
    }
    .info-label{
      text-align: right;
      vertical-align: middle;
    }
    .info-txt{
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/info/info.vue